import ShareUrlInput from './ShareUrlInput';
import './style/index.less';
export default ShareUrlInput;
